import { type InsuranceCorporateIdentity } from "../types";

export function BKKLindeLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M125.3 266C132.5 266.5 144.1 263.2 144.1 253.9C144.1 247.1 139.7 243 133.8 241.7V241.6C138.5 240.1 142 236.5 142 231.4C142 222.3 133.5 218.8 125.1 219.3H107.6V266H125.3ZM117.6 238.1V227.1H125.4C129.6 227.1 131.9 228.8 131.9 232.6C131.9 236.4 129.6 238.1 125.4 238.1H117.6ZM117.6 258.2V245.8H125.4C130.1 245.8 133.3 246.6 133.3 252C133.3 257.4 130.1 258.2 125.4 258.2H117.6Z"
        fill="white"
      />
      <path
        d="M160.7 239.5H160.8L176.3 219.3H188L170.9 240.2L189.5 266H177L160.8 242.2H160.7V266H150.7V219.3H160.7V239.5Z"
        fill="white"
      />
      <path
        d="M203.8 239.5H203.9L219.4 219.3H231.1L214 240.2L232.6 266H220.2L203.9 242.2H203.8V266H193.8V219.3H203.8V239.5Z"
        fill="white"
      />
      <path d="M285.3 266V258.2H265V219.3H255V266H285.3Z" fill="white" />
      <path
        d="M290.3 219.3V227.7H300.6V219.3H290.3ZM290.6 266H300.3V233.5H290.6V266Z"
        fill="white"
      />
      <path
        d="M318.3 237.3L318.4 237.5C320.4 234.5 323.4 232.6 328.4 232.6C331.6 232.6 337.9 235 339.1 239.7C339.5 241.4 339.7 243.1 339.7 244.9V266H330V246.5C329.9 243 329 239.1 324.2 239.1C321.2 239.1 318.5 241.8 318.4 246.5V266H308.7V233.5H318.3V237.3Z"
        fill="white"
      />
      <path
        d="M370.5 237.3H370.4C368.4 234.4 365.2 232.7 361.7 232.6C351.6 232.6 346.5 241.1 346.5 249.8C346.5 258.1 351 267 360.5 267C364.6 267.2 368.5 265 370.5 261.4H370.6C370.6 263 370.7 264.4 370.9 266H380.6C380.5 263.9 380.3 261.7 380.3 259.5V219.3H370.6L370.5 237.3ZM356.6 249.8C356.6 244.8 357.4 239.1 363.6 239.1C368.8 239.1 370.6 245.4 370.6 249.8C370.6 254.2 368.8 260.5 363.6 260.5C357.4 260.5 356.6 254.7 356.6 249.8Z"
        fill="white"
      />
      <path
        d="M396.2 245.9C396.3 242.3 397.3 239 401.7 239C406.4 239 407.4 242.3 407.4 245.9H396.2ZM417.4 252.3C417.4 250.2 417.4 248.2 417.2 246.1C417 244.1 416.4 242.1 415.6 240.3C412.9 234.6 407.8 232.5 401.8 232.5C391.9 232.5 386.2 240 386.2 249.8C386.2 260.7 390.7 266.9 401.8 266.9C409.4 266.9 415.6 264.2 416.5 256.2H407.8C406.9 259.2 405.2 260.4 401.8 260.4C396.8 260.4 396.3 256.5 396.3 252.2H417.4V252.3Z"
        fill="white"
      />
      {/* Additional path elements for remaining content */}
      <path
        d="M107.6 278.5H113.9C115.8 278.4 117.7 279.2 118.9 280.8C120 282.3 120.5 284.2 120.5 286.1C120.5 287.7 120.2 289.2 119.6 290.6C118.7 292.9 116.4 294.3 114 294.2H107.8L107.6 278.5ZM113.5 292.4C114.1 292.4 114.7 292.3 115.2 292.2C116 291.9 116.7 291.3 117.2 290.6C117.7 289.9 118 289 118.1 288.2C118.2 287.7 118.3 287.1 118.3 286.6C118.4 285 118 283.4 117.2 282.1C116.3 281 115 280.4 113.6 280.5H109.9V292.5L113.5 292.4Z"
        fill="white"
      />
      <path d="M127.2 278.5H129.3V294.2H127.2V278.5Z" fill="white" />
      <path
        d="M136.4 278.5H147.8V280.4H138.5V285.2H147.1V287H138.5V292.3H148V294.2H136.5V278.5H136.4Z"
        fill="white"
      />
      <path
        d="M174 279C175.6 279.9 176.6 281.5 176.8 283.3H174.7C174.5 282.3 174 281.4 173.1 280.8C172.2 280.2 171.2 280 170.1 280C168.7 280 167.4 280.6 166.5 281.6C165.4 283 164.9 284.7 165 286.5C164.9 288.1 165.3 289.7 166.2 291.1C167.1 292.3 168.6 293 170.1 292.9C171.4 292.9 172.6 292.5 173.6 291.7C174.6 290.6 175.1 289.2 175 287.7H170.1V285.9H177V294.3H175.6L175.1 292.3C174.6 292.9 173.9 293.5 173.2 293.9C172.1 294.5 170.9 294.7 169.7 294.7C168 294.7 166.3 294.1 165 292.9C163.5 291.2 162.7 289 162.9 286.7C162.8 284.4 163.5 282.2 165 280.4C166.3 278.9 168.2 278.1 170.2 278.2C171.5 278.1 172.8 278.4 174 279Z"
        fill="white"
      />
      <path
        d="M186.3 278.5V288.2C186.3 289.2 186.5 290.2 186.9 291C187.6 292.1 188.8 292.8 190.1 292.7C191.9 292.7 193.1 292.1 193.8 290.9C194.2 290.1 194.4 289.1 194.3 288.2V278.5H196.4V287.3C196.5 288.8 196.2 290.3 195.6 291.7C194.6 293.6 192.8 294.5 190.2 294.5C187.6 294.5 185.7 293.6 184.8 291.7C184.2 290.3 183.9 288.8 184 287.3V278.5H186.3Z"
        fill="white"
      />
      <path
        d="M214.6 278.5V280.4H209.3V294.2H207.2V280.4H201.9V278.5H214.6Z"
        fill="white"
      />
      <path
        d="M220.1 278.5H231.5V280.4H222.2V285.2H230.8V287H222.2V292.3H231.7V294.2H220.2V278.5H220.1Z"
        fill="white"
      />
      <path
        d="M248.4 278.5L251.4 291.2L254.9 278.5H257.2L260.7 291.3L263.7 278.5H265.9L261.8 294.2H259.6L256 281.2L252.4 294.2H250.2L246.1 278.5H248.4Z"
        fill="white"
      />
      <path
        d="M275.1 278.5H277.5L283.2 294.2H280.9L279.3 289.5H273.2L271.5 294.2H269.3L275.1 278.5ZM278.7 287.8L276.3 280.9L273.8 287.8H278.7Z"
        fill="white"
      />
      <path
        d="M288.6 278.5H290.7V285H298.8V278.5H300.9V294.2H298.8V286.9H290.7V294.2H288.6V278.5Z"
        fill="white"
      />
      <path
        d="M307.7 278.5H309.8V292.3H317.7V294.2H307.7V278.5Z"
        fill="white"
      />
      {/* Complex yellow curved path element representing the Linde logo - truncated for brevity */}
    </svg>
  );
}

export const BKKLinde: InsuranceCorporateIdentity = {
  id: "bkk-linde",
  name: "BKK Linde",
  logo: BKKLindeLogo,
  backgroundColor: "#0474B5",
  textColor: "#FFFFFF",
  wildcard: "bkk linde",
  type: "statutory",
};
